import { render, staticRenderFns } from "./SiteNavDesktopV2ShopNav.vue?vue&type=template&id=4224289d&scoped=true&lang=pug"
import script from "./SiteNavDesktopV2ShopNav.vue?vue&type=script&lang=js"
export * from "./SiteNavDesktopV2ShopNav.vue?vue&type=script&lang=js"
import style0 from "./SiteNavDesktopV2ShopNav.vue?vue&type=style&index=0&id=4224289d&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4224289d",
  null
  
)

export default component.exports